import React from "react";
import { PORTALS } from "../../constants";

/**
 * An image representing the company logo for use in the purchase flow header.
 * Displays a different image depending on the screen size (essentially a different image for desktop/mobile).
 * Displays the correct logo based on the availability location (ex. SHAPA_WEBSITE or CLEARSTEP_WEBSITE).
 */
const HeaderCompanyLogo = ({ portal }) => {
  let largeLogo, smallLogo;
  let largeWidth;
  let linkUrl;

  if (portal === PORTALS.SHAPA || portal === PORTALS.SHAPA_HEALTH) {
    largeLogo = '/img/logo.png';
    smallLogo = '/img/shapa-icon.png';
    largeWidth = "100px";
    linkUrl = '/';
  }
  else if (portal === PORTALS.CLEARSTEP) {
    largeLogo = '/img/clearstep_dark.png';
    smallLogo = '/img/clearstep_small.png';
    largeWidth = "200px";
    linkUrl = 'https://www.myclearstep.com/'
  }

  return (
    <React.Fragment>
      <a href={linkUrl} className="p-0">
        <img
          src={largeLogo}
          alt='desktop-logo'
          className='img-fluid d-none d-lg-block ms-4'
          style={{ width: largeWidth }}
        />
      </a>
      <a href={linkUrl} className="p-0">
        <img
          src={smallLogo}
          alt='mobile-logo'
          className='img-fluid d-block d-lg-none'
          style={{ width: "40px", height: "40px" }}
        />
      </a>
    </React.Fragment>
  );
};

export default HeaderCompanyLogo;